import {List} from 'immutable';

export const authoringQuestionSetModelValidators = {
  getName() {
    if (this.getName().length === 0) {
      return List(['You must provide a question set name.']);
    }
    if (this.getName().length > 65) {
      return List(['Question set names must be 65 characters or less.']);
    }
    return null;
  }
};
